import { css } from "lit";

export const progressBarStyles = css`
  :host {
    display: block;
    width: 100%;
    height: 2px;
  }

  progress {
    position: absolute;
    top: 0;
    appearance: none;
    width: 100%;
    height: 2px;
    background-color: var(--sds-color-border-default-default);
    border: none;
    overflow: hidden;
    margin: 0;
    padding: 0;
    display: block;
  }

  progress::-webkit-progress-bar {
    background-color: var(--sds-color-border-default-default);
  }

  progress::-webkit-progress-value {
    background-color: var(--sds-color-text-brand-default);
    transition: width 0.3s ease;
  }

  progress::-moz-progress-bar {
    background-color: var(--sds-color-text-brand-default);
    transition: width 0.3s ease;
  }
`;
